<template>
  <div v-if="user_data.orders!=null">
    <CModal
        :title="customer_name"
        color="primary"
        :show.sync="modal"
    >
      <CTabs>
        <CTab
            title="رزرو ها"
        >
          <CRow>
            <CCol col="12">
              <div v-for="order in user_data.orders.orders">
                <div class="info-row">
                  <span class="info-label">رزرو:</span>
                  <span class="info-value mx-1">{{ get_date_time(order.reserve_time.date) }}</span>
                  <span class="info-value text-danger" v-if="order.status==0">لغو شده</span>
                  <span class="info-value text-success" v-if="order.status!=0">تایید شده</span>
                </div>
                <hr>
              </div>
            </CCol>
          </CRow>
        </CTab>
        <CTab
            title="هدایا"
        >
          <div class="cards-grid">
            <div
                v-for="row in user_data.promotions"
                :key="row.id"
                class="card-item"
                :class="{
          'is-used': row.is_used,
          'is-revoked': row.is_revoked,
          'is-expired': isExpired(row)
        }"
            >
              <!-- ===== هدر کارت ===== -->
              <div class="card-header">
                <div class="card-user">
                  <span class="user-name">{{ row.user ? row.user.name : 'کاربر ناشناس' }}</span>
                  <span class="user-phone" v-if="row.user && row.user.phone">
              📱 {{ row.user.phone }}
            </span>
                </div>
                <div class="card-status">
                  <span v-if="row.is_used" class="badge badge-success">✓ استفاده شده</span>
                  <span v-else-if="isExpired(row)" class="badge badge-danger">✕ منقضی</span>
                  <span v-else-if="row.is_revoked" class="badge badge-danger">✕ لغو شده</span>
                  <span v-else class="badge badge-active">● فعال</span>
                </div>
              </div>

              <!-- ===== بدنه کارت ===== -->
              <div class="card-body">
                <div class="card-row">
                  <span class="card-label">جشنواره:</span>
                  <span class="card-value">{{ row.promotion ? row.promotion.title : '-' }}</span>
                </div>

                <div class="card-row code-row">
                  <span class="card-label">کد کوپن:</span>
                  <span class="code-value">{{ row.code }}</span>
                  <button class="btn-copy" @click="copyCode(row.code)" title="کپی کد">📋</button>
                </div>

                <div class="card-row">
                  <span class="card-label">تخفیف:</span>
                  <span class="card-value discount-text">{{ row.discount_text ? row.discount_text : getDiscountText(row) }}</span>
                </div>

                <div class="card-row">
                  <span class="card-label">تاریخ انقضا:</span>
                  <span class="card-value" :class="{ 'expired-date': isExpired(row) }">
              {{ formatDate(row.expires_at) }}
              <span v-if="!isExpired(row) && !row.is_used && !row.is_revoked" class="days-left">
                ({{ daysLeft(row.expires_at) }} روز مانده)
              </span>
            </span>
                </div>
              </div>

              <!-- ===== فوتر کارت (عملیات) ===== -->
              <div class="card-footer">
                <template v-if="!row.is_used && !row.is_revoked && !isExpired(row)">
                  <button class="btn-action btn-use" @click="openUseDialog(row)">
                    ✅ استفاده
                  </button>
                  <button class="btn-action btn-revoke" @click="revokePromotion(row)">
                    ❌ لغو
                  </button>
                </template>
                <template v-else>
                  <span class="no-action">—</span>
                </template>
              </div>
            </div>
          </div>

        </CTab>
        <CTab
            title="سوابق"
        >
          <div v-for="comment in user_data.comments" style="border:1px solid gray;" class="p-1 m-1 rounded">
            <p>{{comment.summary}}</p>
            <p>{{get_date_time(comment.created_at)}}</p>
          </div>
<CTextarea
  placeholder="توضیحات ..."
  v-model="admin_message"
  />
          <CButton color="success"
                   @click="add_admin_comment()"
                   :disabled="admin_message.length==0">ثبت توضیحات برای مشتری</CButton>
        </CTab>
      </CTabs>

      <template #footer>
        <CButton @click="modal = false" color="dark">بستن</CButton>
      </template>
    </CModal>

  </div>

</template>

<script>
import router from "@/router" ;
import axios from 'axios';
import {bus} from "../main";
export default {
  name: 'CustomerInfo',
  components: {

  },
  data() {
    return {
      admin_message:'',
      modal:false,
      customer_id:0,
      customer_name:"",
     user_data:{},
    }
  },
  computed: {

  },
  mounted() {
    var self = this
    bus.$on('open_customer_data', (data) => {
      self.customer_id = data.customer_id
      self.get_my_customer_info();
    });
  },
  methods: {
    isExpired(row) {
      if (!row || !row.expires_at) return false;
      return new Date(row.expires_at) < new Date() && !row.is_used && !row.is_revoked;
    },
    daysLeft(expiresAt) {
      const diff = new Date(expiresAt) - new Date();
      const days = Math.ceil(diff / (1000 * 60 * 60 * 24));
      return days > 0 ? days : 0;
    },
    formatDate(date) {
      if (!date) return '-';
      const d = new Date(date);
      return `${d.getFullYear()}/${String(d.getMonth() + 1).padStart(2, '0')}/${String(d.getDate()).padStart(2, '0')} ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
    },
    getDiscountText(row) {
      const promotion = row.promotion;
      if (!promotion) return '-';

      switch (promotion.reward_type) {
        case 'percentage':
          let text = `${promotion.reward_value}% تخفیف`;
          if (promotion.max_discount_amount) {
            text += ` (تا سقف ${this.formatPrice(promotion.max_discount_amount)})`;
          }
          return text;
        case 'fixed_amount':
          return `${this.formatPrice(promotion.reward_value)} تخفیف`;
        case 'free_service':
          return '🎁 یک خدمت رایگان';
        default:
          return '-';
      }
    },

    formatPrice(value) {
      if (!value) return '۰';
      return new Intl.NumberFormat('fa-IR').format(value) + ' تومان';
    },

    async copyCode(code) {
      try {
        await navigator.clipboard.writeText(code);
        this.$message?.success('کد کوپن کپی شد!') || alert('کد کوپن کپی شد!');
      } catch {
        const input = document.createElement('input');
        input.value = code;
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        this.$message?.success('کد کوپن کپی شد!') || alert('کد کوپن کپی شد!');
      }
    },

    get_my_customer_info(){
      var formData = new FormData();
formData.append("customer_id",this.customer_id)
      axios.post('/api/admin/user/get_my_customer_info',formData, {})
          .then(response => {
            this.user_data = response.data
            this.customer_name = response.data.orders.name
            this.modal = true
          })
          .catch(error => {
            console.error('Error fetching customers:', error);
          });
    },
    add_admin_comment(){
      var formData = new FormData();
formData.append("customer_id",this.customer_id)
formData.append("summary",this.admin_message)
      axios.post('/api/admin/user/add_admin_comment',formData, {})
          .then(response => {
            this.admin_message = ''
            this.user_data.comments.push(response.data)

          })
          .catch(error => {
            console.error('Error fetching customers:', error);
          });
    }

  },
  watch: {

  }
}
</script>

<style scoped>
.user-name-section {
  padding: 15px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  background-color: #ffffff;
  margin: 10px;
  border-radius: 5px;
}

.user-name-text {
  color: #000;
  font-weight: 600;
  font-size: 14px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 8px;
}

.subscription-section {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.subscription-text {
  color: #000;
  font-size: 12px;
  text-align: center;
  font-weight: 500;
}

/* Style for logout button */
::v-deep .c-sidebar-nav-item a[href="#logout"] {
  color: #fff !important;
}

::v-deep .c-sidebar-nav-item:has(a[href="#logout"]) {
  background-color: #dc3545 !important;
  margin-top: 10px;
}

::v-deep .c-sidebar-nav-item:has(a[href="#logout"]):hover {
  background-color: #c82333 !important;
}

::v-deep .c-sidebar-nav-item:has(a[href="#logout"]) .c-sidebar-nav-icon {
  color: #fff !important;
}

.logout-button {
  display: flex;
  gap: 20px;
  align-items: center;
  padding: 0.75rem 1rem;
  margin: 5px 10px;
  background-color: transparent;
  color: #6e82a5;
  cursor: pointer;
  border-radius: 9px;
  transition: all 0.2s;
  border: none;
  width: calc(100% - 20px);
}

.logout-button:hover {
  color: #8351ec;
  background-color: #F5F0FF;
}

.logout-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  fill: currentColor;
}

.logout-button span {
  flex: 1;
  text-align: right;
}

/* Override h-100 for c-sidebar-nav to fit content */
::v-deep ul.c-sidebar-nav.h-100.ps.ps__rtl,
::v-deep .c-sidebar-nav.h-100,
::v-deep .c-sidebar-nav.h-100.ps,
::v-deep .c-sidebar-nav.h-100.ps__rtl,
::v-deep .c-sidebar-nav.ps.ps__rtl {
  height: auto !important;
  min-height: auto !important;
  max-height: none !important;
  flex: 0 0 auto !important;
}
.cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  gap: 16px;
}

/* ========================================== */
/* کارت کوپن */
/* ========================================== */
.card-item {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  transition: all 0.3s;
  border-right: 4px solid #409eff;
}

.card-item:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.10);
}

.card-item.is-used {
  border-right-color: #67c23a;
  opacity: 0.75;
}

.card-item.is-revoked {
  border-right-color: #909399;
  opacity: 0.65;
}

.card-item.is-expired {
  border-right-color: #f56c6c;
  opacity: 0.6;
}

/* ===== هدر کارت ===== */
.card-header {
  padding: 14px 18px 10px 18px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 8px;
}

.card-user {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.user-name {
  font-weight: 600;
  color: #2c3e50;
  font-size: 15px;
}

.user-phone {
  font-size: 12px;
  color: #909399;
}

.card-status {
  display: flex;
  align-items: center;
}
.card-body {
  padding: 12px 18px;
}

.card-row {
  display: flex;
  align-items: baseline;
  gap: 6px;
  padding: 3px 0;
  font-size: 13px;
  color: #303133;
  flex-wrap: wrap;
}

.card-label {
  font-weight: 500;
  color: #909399;
  min-width: 70px;
}

.card-value {
  color: #303133;
}

.discount-text {
  font-weight: 500;
  color: #409eff;
}

.code-row {
  background: #f5f7fa;
  padding: 6px 10px;
  border-radius: 6px;
  margin: 4px 0;
}

.code-value {
  font-family: 'Courier New', monospace;
  font-weight: bold;
  font-size: 14px;
  color: #2c3e50;
  letter-spacing: 1px;
}

.btn-copy {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  padding: 0 4px;
  transition: transform 0.2s;
}

.btn-copy:hover {
  transform: scale(1.2);
}

.expired-date {
  color: #f56c6c;
}

.days-left {
  color: #67c23a;
  font-size: 12px;
}

</style>
